<template>
  <div>
    <el-form class="page-panel-search-form" :inline="true">
      <!-- <el-form-item>
        <el-input placeholder="请输入岗位"> </el-input>
      </el-form-item>
      <el-form-item>
        <el-input placeholder="请选择招聘状态"> </el-input>
      </el-form-item>
      <el-form-item>
        <el-input placeholder="请选择时间"> </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="default" icon="el-icon-search"></el-button>
      </el-form-item> -->
      <el-form-item class="page-panel-search-form-right-button">
        <el-button type="primary" @click="openDialog">
          新增
        </el-button>
      </el-form-item>
    </el-form>
    <el-table :data="recruitList" border stripe ref="multipleTable">
      <el-table-column width="50" align="center" label="序号">
        <template slot-scope="scope">{{(scope.$index+1)+((searchModel.pageNo-1)*searchModel.pageSize)}}</template>
      </el-table-column>
      <el-table-column align="center" prop="jobName" label="招聘岗位">
      </el-table-column>
      <el-table-column align="center" prop="addTime" label="发布日期">
      </el-table-column>
      <el-table-column align="center" label="是否展示">
        <template slot-scope="scope">
          <el-switch active-color="#13ce66" inactive-color="#ff4949" :active-value="0" :inactive-value="1"
            v-model="scope.row.isHide" @change="hideJob(scope.row)" active-text="是" inactive-text="否">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click.stop="getJob(scope.row,'view')">查看</el-button>
          <el-button type="text" @click.stop="getJob(scope.row,'update')">编辑</el-button>
          <el-button type="text" @click.stop="delJob(scope.row.jobId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-panel-footer">
      <el-pagination :current-page.sync='searchModel.pageNo' @current-change='getJobList'
        :page-size='searchModel.pageSize' layout='prev, pager, next, jumper' :total='total'>
      </el-pagination>
    </div>
    <el-dialog title="招聘信息查看" :visible.sync="paperDialog" width="40%">
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisable" width="40%">
      <el-form>
        <table class="form-editor">
          <tr>
            <th><span class="required_column">*</span>招聘岗位</th>
            <td>
              <el-input placeholder="请输入岗位名称" v-model="jobParam.jobName"></el-input>
            </td>
          </tr>
          <tr>
            <th><span class="required_column">*</span>任职要求</th>
            <td>
              <table class="form-editor-table">
                <tr v-for="(item,index) in jobParam.jobRequire" :key="index">
                  <td class="anwser_td">
                    <el-input placeholder="" v-model="jobParam.jobRequire[index]"></el-input>
                  </td>
                  <td class="del_td" v-if="jobParam.jobRequire.length>1">
                    <el-button type="text" class="el-icon-minus" @click="delRequire(index)"></el-button>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <th></th>
            <td>
              <el-button type="text" @click="addRequire">+ 新增要求</el-button>
            </td>
          </tr>
          <tr>
            <th><span class="required_column">*</span>岗位职责</th>
            <td>
              <table class="form-editor-table">
                <tr v-for="(item,index) in jobParam.jobDuty" :key="index">
                  <td class="anwser_td">
                    <el-input placeholder="" v-model="jobParam.jobDuty[index]"></el-input>
                  </td>
                  <td class="del_td" v-if="jobParam.jobDuty.length>1">
                    <el-button type="text" class="el-icon-minus" @click="delDuty(index)"></el-button>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <th></th>
            <td>
              <el-button type="text" @click="addDuty">+ 新增职责</el-button>
            </td>
          </tr>
          <tr>
            <th>招聘人数</th>
            <td>
              <el-input-number label="排列顺序" v-model="jobParam.jobNum"></el-input-number>
            </td>
          </tr>
          <tr>
            <th>排列顺序</th>
            <td>
              <el-input-number label="排列顺序" v-model="jobParam.jobOrder"></el-input-number>
            </td>
          </tr>
        </table>
      </el-form>
      <span slot="footer">
        <el-button @click=" dialogVisable= false">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as recruitApi from '@/api/adminApi/zh/recruit';
export default {
  data() {
    return {
      total: 0,
      jobParam: {
        jobDuty: new Array(2),
        jobRequire: new Array(2)
      },
      editorConfig: {
        initialFrameWidth: '100%',
        initialFrameHeight: 400,
        zIndex: 0
      },
      activePaper: '',
      paperDialog: false,
      dialogVisable: false,
      dialogTitle: '新增招聘信息',
      recruitList: [],
      searchModel: {
        pageNo: 1,
        pageSize: 15
      }
    };
  },
  methods: {
    delDuty(index) {
      this.jobParam.jobDuty.splice(index, 1);
    },
    delRequire(index) {
      this.jobParam.jobRequire.splice(index, 1);
    },
    checkInfo(info) {
      if (!info.jobName) {
        this.$notify({
          title: '警告',
          message: '请输入岗位名称',
          type: 'warning'
        });
        return false;
      } else {
        return true;
      }
    },
    openDialog() {
      this.dialogTitle = '新增招聘信息';
      this.jobParam = {
        jobDuty: new Array(2),
        jobRequire: new Array(2)
      };
      this.dialogVisable = true;
    },
    addDuty() {
      this.jobParam.jobDuty.push('');
    },
    addRequire() {
      this.jobParam.jobRequire.push('');
    },
    hideJob(row) {
      recruitApi.hideJob({ jobId: row.jobId, isHide: row.isHide }).then(res => {
        this.getJobList();
      });
    },
    getJob(row, status) {
      recruitApi.getJob({ jobId: row.jobId }).then(res => {
        if (status === 'view') {
          this.activePaper = JSON.parse(JSON.stringify(res.data));
          this.paperDialog = true;
        } else {
          this.dialogTitle = '编辑招聘信息';
          this.jobParam = JSON.parse(JSON.stringify(res.data));
          this.dialogVisable = true;
        }
      });
    },
    delJob(jobId) {
      this.$confirm('是否确认删除该招聘信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          recruitApi.delJob({ jobId: jobId }).then(res => {
            this.getJobList();
          });
        })
        .catch(action => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    },
    add() {
      if (this.checkInfo(this.jobParam)) {
        if (this.jobParam.jobId) {
          recruitApi.upJob(this.jobParam).then(res => {
            this.getJobList();
            this.dialogVisable = false;
            this.jobParam = {};
          });
        } else {
          recruitApi.addJob(this.jobParam).then(res => {
            this.getJobList();
            this.dialogVisable = false;
            this.jobParam = {};
          });
        }
      }
    },
    getJobList() {
      recruitApi.getJobList(this.searchModel).then(res => {
        this.recruitList = res.data.list;
        this.total = res.data.pageTotal;
      });
    }
  },
  created() {
    this.getJobList();
  }
};
</script>
<style lang="stylus" scoped>
.anwser_td {
  padding 10px 0px 10px 0px !important
}
.del_td {
  text-align center
  padding 0px !important
  line-height 10px
}
</style>



// WEBPACK FOOTER //
// src/pages/adminCenter/page/article/recruit/list.vue